export default {"src":"/_next/static/media/logo.def94ee6.svg","height":42,"width":200,"blurWidth":0,"blurHeight":0};